import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const PageInfo = ({ message}) => {
  const theme = useTheme();
  const t = theme.custom;

  return (
    <Box
      sx={{
        px: 3,
        py: 1.25,
        background: `linear-gradient(90deg, ${t.accent ?? "#1976d2"}12 0%, transparent 100%)`,
        borderLeft: `3px solid ${t.accent ?? "#1976d2"}`,
        borderBottom: `1px solid ${t.border2 ?? t.border ?? "#e0e0e0"}`,
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexShrink: 0,
      }}
    >
      <Box
        component="span"
        sx={{
          fontSize: "0.8125rem",
          fontWeight: 500,
          color: t.textSecondary ?? "text.secondary",
          letterSpacing: "0.01em",
        }}
      >
        {message}
      </Box>
    </Box>
  );
};

export default PageInfo;